const ON_COLOUR = {
    primary: "on-primary",
    neutral: "on-neutral",
    danger: "on-danger",
    success: "on-success",
    warning: "on-warning",
    information: "on-info",
    highlight: "on-highlight",
};
const FONT_WEIGHT = /^\s*(?:\d{3}|normal|bold|bolder|lighter)\s+/;
export const cellStyleOverride = ({ color, emphasis = "text", weight, align }, baseFontStyle) => {
    const themeOverride = {};
    if (color && emphasis === "text")
        themeOverride.textDark = `var(--colour-text-${color}-default)`;
    else if (color && emphasis === "tonal") {
        themeOverride.bgCell = `var(--colour-surface-${color}-tonal)`;
        themeOverride.textDark = `var(--colour-text-${color}-on-tonal)`;
    }
    else if (color && emphasis === "solid") {
        themeOverride.bgCell = `var(--colour-surface-${color}-default)`;
        themeOverride.textDark = `var(--colour-text-${color}-${ON_COLOUR[color]})`;
    }
    else if (color && emphasis === "inverse") {
        themeOverride.bgCell = `var(--colour-surface-${color}-inverse)`;
        themeOverride.textDark = `var(--colour-text-${color}-on-inverse)`;
    }
    if (weight === "bold")
        themeOverride.baseFontStyle = `bold ${baseFontStyle.replace(FONT_WEIGHT, "")}`;
    return align ? { themeOverride, contentAlign: align } : { themeOverride };
};
/** Merges a semantic style under the cell's own `themeOverride` and `contentAlign`, which win. */
export const applyCellStyle = (cell, style, baseFontStyle) => {
    const { themeOverride, contentAlign } = cellStyleOverride(style, baseFontStyle);
    return {
        ...cell,
        contentAlign: cell.contentAlign ?? contentAlign,
        themeOverride: { ...themeOverride, ...cell.themeOverride },
    };
};
const BORDER_STRENGTHS = new Set(["default", "dark", "darker"]);
export const borderToken = (color) => {
    if (BORDER_STRENGTHS.has(color))
        return `var(--colour-border-${color})`;
    if (color in ON_COLOUR)
        return `var(--colour-border-${color}-default)`;
    return color;
};
/**
 * The section separator: a 5px bar in the dark border colour, drawn as a row one
 * pixel shorter whose bar the next row's top grid line completes.
 */
export const SEPARATOR = { height: 5, color: "var(--colour-border-dark)" };
/** Glide draws the line along a row's top edge in that row's horizontal border colour. */
export const SEPARATOR_ROW = { horizontalBorderColor: SEPARATOR.color };
export const STRIPE = { bgCell: "var(--colour-surface-variant)" };
/** The grid's base look, from the `@artis/ui` tokens; the `theme` prop overrides any of it. */
export const DESIGN_THEME = {
    accentColor: "var(--colour-border-primary-default)",
    accentFg: "var(--colour-text-primary-on-primary)",
    accentLight: "var(--colour-surface-primary-tonal)",
    textDark: "var(--colour-text-default)",
    textMedium: "var(--colour-text-light)",
    textLight: "var(--colour-text-lighter)",
    textBubble: "var(--colour-text-default)",
    bgIconHeader: "var(--colour-surface-neutral-default)",
    fgIconHeader: "var(--colour-text-neutral-on-neutral)",
    textHeader: "var(--colour-text-default)",
    textGroupHeader: "var(--colour-text-light)",
    textHeaderSelected: "var(--colour-text-primary-on-primary)",
    bgCell: "var(--colour-surface-page-default)",
    bgCellMedium: "var(--colour-surface-variant)",
    bgHeader: "var(--colour-surface-container-variant)",
    bgHeaderHasFocus: "var(--colour-surface-variant-hover)",
    bgHeaderHovered: "var(--colour-surface-hover)",
    bgBubble: "var(--colour-surface-variant)",
    bgBubbleSelected: "var(--colour-surface-primary-tonal)",
    bgSearchResult: "var(--colour-surface-highlight-tonal)",
    borderColor: "var(--colour-border-default)",
    horizontalBorderColor: "var(--colour-border-default)",
    headerBottomBorderColor: "var(--colour-border-default)",
    drilldownBorder: "var(--colour-border-dark)",
    linkColor: "var(--colour-text-primary-default)",
    resizeIndicatorColor: "var(--colour-border-primary-default)",
};
//# sourceMappingURL=semantics.js.map